// extracted by mini-css-extract-plugin
module.exports = {"remitanceSnippet":"style_remitanceSnippet__klX1W","info":"style_info__3EC8F","unread":"style_unread__9gUMX"};